import { createReducer } from '@reduxjs/toolkit';

import { getNotificationSettings, setAlertMedium, upsertAlertAction } from './actions';

export const SETTINGS_STATE = {
  alertsMap: null,
};

export const settingsReducer = createReducer(SETTINGS_STATE, (builder) => {
  builder
    .addCase(getNotificationSettings.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    })
    .addCase(getNotificationSettings.rejected, (state) => {
      return { ...state };
    })
    .addCase(setAlertMedium, (state, action) => {
      const { type, medium, enabled } = action.payload;
      const alertsMap = { ...state?.alertsMap };
      alertsMap[type] = { ...alertsMap[type], [medium]: enabled };

      return { ...state, alertsMap };
    })
    .addCase(upsertAlertAction.fulfilled, (state) => {
      return { ...state };
    })
    .addCase(upsertAlertAction.rejected, (state) => {
      return { ...state };
    })
    .addDefaultCase((state) => state);
});
